export type TradeDataRefreshReason = "order-action" | "pending-txn-success" | "position-removal";

type TradeDataRefreshListener = (reason: TradeDataRefreshReason) => void;
type TimeoutId = ReturnType<typeof setTimeout>;

export const TRADE_DATA_REFRESH_DELAYS_MS = [0, 2500, 7500, 15000];

const listeners = new Set<TradeDataRefreshListener>();
const scheduledRefreshes = new Set<TimeoutId>();

export function requestTradeDataRefresh(reason: TradeDataRefreshReason = "order-action") {
  Array.from(listeners).forEach((listener) => listener(reason));
}

export function subscribeTradeDataRefresh(listener: TradeDataRefreshListener) {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

export function clearScheduledTradeDataRefreshes(clearTimer: typeof clearTimeout = clearTimeout) {
  scheduledRefreshes.forEach((timeoutId) => clearTimer(timeoutId));
  scheduledRefreshes.clear();
}

export function scheduleTradeDataRefresh({
  reason = "order-action",
  delaysMs = TRADE_DATA_REFRESH_DELAYS_MS,
  requestRefresh = requestTradeDataRefresh,
}: {
  reason?: TradeDataRefreshReason;
  delaysMs?: number[];
  requestRefresh?: (reason: TradeDataRefreshReason) => void;
} = {}) {
  if (scheduledRefreshes.size > 0) {
    return;
  }

  delaysMs.forEach((delayMs) => {
    if (delayMs <= 0) {
      requestRefresh(reason);
      return;
    }

    const timeoutId = setTimeout(() => {
      scheduledRefreshes.delete(timeoutId);
      requestRefresh(reason);
    }, delayMs);

    scheduledRefreshes.add(timeoutId);
  });
}
